import { integrations as integrationsConstants } from 'common/cep/constants'

export const getIntegrationName = (cepName: string) => {
  const integration = integrationsConstants.find(
    (integration) => integration.value === cepName
  )
  return integration?.label ?? cepName
}
